import { render, staticRenderFns } from "./ButtonPill.vue?vue&type=template&id=71ae7055&scoped=true&"
import script from "./ButtonPill.vue?vue&type=script&lang=js&"
export * from "./ButtonPill.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPill.vue?vue&type=style&index=0&id=71ae7055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ae7055",
  null
  
)

export default component.exports